import styles from "./Post.module.scss";
import Image from "next/image";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { useAppContext } from "@/context/AppContext";

interface PostProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- this is element we parse from smash-balloon html response
  image: any;

  show_border_radius: boolean;
  show_box_shadow: boolean;
  show_card_box: boolean;
}

export const Post = ({
  image,
  show_border_radius,
  show_box_shadow,
  show_card_box,
}: PostProps) => {
  // const [imageURL, setImageURL] = useState("");
  const { setInstagramModal } = useAppContext();
  const { getLabel } = useGlobalContext();

  // Disable webp conversion because the plugin provides the image in webp format already
  // useEffect(() => {
  //   async function fetchThumbnail() {
  //     const srcUrl = image.src;
  //     if (srcUrl) {
  //       const thumbnailDataUrl = await fetch(`/api/fetchInstagramImage`, {
  //         method: "POST",
  //         body: srcUrl,
  //       })
  //         .then((response) => {
  //           if (!response.ok) {
  //             throw new Error("Network response was not ok");
  //           }
  //           return response.json();
  //         })
  //         .then((data) => {
  //           const dataURL = data.instagramImage.dataURL;
  //           return dataURL;
  //         })
  //         .catch((error) => {
  //           console.error("Error:", error);
  //         });

  //       if (thumbnailDataUrl) {
  //         setImageURL(thumbnailDataUrl);
  //       }
  //     }
  //   }
  //   fetchThumbnail();
  //   //eslint-disable-next-line
  // }, []);

  return (
    <button
      onClick={() => {
        setInstagramModal({ info: image, open: true });
      }}
      className={styles["post-button"]}
      aria-label={`${getLabel("open_project")} Modal ${image.caption}`}
    >
      {/* <div
          className={`${show_border_radius ? styles["has-border-radius"] : ""} ${show_box_shadow ? "has-box-shadow" : ""}`}
          dangerouslySetInnerHTML={{
            __html: customSanitize(image.el.outerHTML),
          }}
        /> */}
      <div
        className={` ${show_card_box ? "is-box" : ""} ${show_border_radius && show_card_box ? "has-border-radius" : ""} ${show_box_shadow && show_card_box ? "has-box-shadow" : ""}`}
      >
        {/* <img
            src={image.src}
            alt={image.caption}
          /> */}
        {image.src && (
          <Image
            src={image.src}
            alt={image.caption}
            width={200}
            height={200}
            quality={90}
          />
        )}
      </div>
    </button>
  );
};
